import { apiClient } from "@/core/api/ApiClient";
import { ChargeDto, EntityType } from "@/core/api/generated/v1";

import BaseEntityDeleteModal, {
  BaseEntityDeleteModalInheritableProps,
} from "../components/BaseEntityDeleteModal";

export interface OwnProps {
  entity: ChargeDto;
}

type Props = OwnProps & BaseEntityDeleteModalInheritableProps;

export default function ChargeDeleteModal({ entity, ...otherProps }: Props) {
  return (
    <BaseEntityDeleteModal
      entityType={EntityType.Charge}
      entity={entity}
      entityId={entity.id}
      deleteFunc={async (params) => {
        await apiClient.chargesApi.apiV1ChargesChargeIdDelete({
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          chargeId: params.entityId,
        });
      }}
      {...otherProps}
    />
  );
}
